import { render } from "./Gamelife.vue?vue&type=template&id=499d014c"
import script from "./Gamelife.vue?vue&type=script&lang=js"
export * from "./Gamelife.vue?vue&type=script&lang=js"

import exportComponent from "G:\\MET-CS601-Term-Project\\cs601-term-project\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__